import { Link } from 'react-router-dom';
import { dailyCompetition } from '@/mocks/site';

const ENTRY_IMG_1 = 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20style%2C%20celebrity%20couple%20walking%20into%20apartment%20building%20entrance%2C%20blurred%20motion%2C%20dim%20street%20lamp%20lighting%2C%20mysterious%20and%20secretive%20atmosphere%2C%20urban%20night%20scene%20with%20cinematic%20grain&width=500&height=350&seq=comp-entry-01&orientation=landscape';
const ENTRY_IMG_2 = 'https://readdy.ai/api/search-image?query=Recording%20studio%20booth%20with%20microphone%20and%20lyric%20sheets%2C%20dramatic%20spotlight%20on%20empty%20mic%20stand%2C%20urban%20music%20production%20aesthetic%20with%20warm%20amber%20tones%2C%20creative%20tension%20atmosphere%2C%20editorial%20photography&width=500&height=350&seq=comp-entry-02&orientation=landscape';
const ENTRY_IMG_3 = 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20collapse%20concept%2C%20expensive%20items%20falling%20like%20dominoes%2C%20dramatic%20lighting%20with%20gold%20and%20shadow%20contrast%2C%20opulent%20interior%20in%20background%20going%20dark%2C%20editorial%20social%20commentary%20photography&width=500&height=350&seq=comp-entry-03&orientation=landscape';

const entryImages = [ENTRY_IMG_1, ENTRY_IMG_2, ENTRY_IMG_3];

export default function DailyCompetition() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-accent-600 uppercase tracking-wide mb-2">
            <i className="ri-trophy-line"></i> 每日大赛
          </span>
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            {dailyCompetition.title}
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            {dailyCompetition.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
          {dailyCompetition.entries.map((entry, idx) => (
            <div
              key={entry.id}
              className="group relative overflow-hidden rounded-lg bg-background-50 border border-background-200/70 transition-all hover:border-accent-200"
            >
              <div className="relative h-56">
                <img
                  src={entryImages[idx]}
                  alt={entry.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={entry.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-white text-sm font-bold">
                    {idx + 1}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white font-semibold text-sm leading-snug mb-2">{entry.title}</h3>
                  <div className="flex items-center gap-3">
                    <button className="flex items-center gap-1 text-white/80 text-xs hover:text-accent-300 transition-colors whitespace-nowrap cursor-pointer">
                      <i className="ri-thumb-up-line"></i> 投票 ({entry.votes.toLocaleString()})
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/meiri-dasai"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-colors"
          >
            查看全部大赛 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}